// extracted by mini-css-extract-plugin
export var layoutContainer = "_cw-0";
export var layoutContainerNoRounding = "_cw-6";
export var layoutContainerOpen = "_cw-5";
export var layoutContainerResizing = "_cw-1";
export var mainContent = "_cw-2";
export var resizeDivider = "_cw-3";
export var slidePanel = "_cw-4";